import { PropsWithChildren } from "react";
import { CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface DescriptionListContentProps extends PropsWithChildren {
  className?: string;
}

const DescriptionListContent = ({
  children,
  className,
}: DescriptionListContentProps) => {
  return (
    <CardContent
      className={cn(
        "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 pt-5",
        className,
      )}
    >
      {children}
    </CardContent>
  );
};

export default DescriptionListContent;
